import React, { useEffect } from "react";
import "./modal.scss";

export default (props) => {
  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") props.onClose(null);
    };
    window.document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.document.body.style.overflow = "auto";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [props.onClose]);

  return (
    <div
      className={`portfolio-modal modal fade `}
      id={props.id}
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-label={props.title}
    >
      <div className="modal-content">
        <button
          type="button"
          className="close-modal"
          aria-label="Close project details"
          autoFocus
          onClick={() => {
            props.onClose(null);
          }}
        >
          ×
        </button>
        <div className="container">
          <div className="modal-body">
            <h2>{props.title}</h2>

            {/*<hr className="star-primary" />*/}

            {props.children}

            <button
              type="button"
              className="btn btn-default"
              onClick={() => {
                props.onClose(null);
              }}
            >
              <i className="fa fa-times" /> Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
